var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 112,
    viewBox: "0 0 111 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3337 109.335H13.3337C10.5047 109.335 7.79157 108.211 5.79119 106.21C3.7908 104.21 2.66699 101.497 2.66699 98.668V61.3346C2.66699 58.5057 3.7908 55.7926 5.79119 53.7922C7.79157 51.7918 10.5047 50.668 13.3337 50.668H29.3337M66.667 40.0013V18.668C66.667 14.4245 64.9813 10.3548 61.9807 7.35426C58.9801 4.35368 54.9105 2.66797 50.667 2.66797L29.3337 50.668V109.335H89.4937C92.0661 109.364 94.5623 108.462 96.5225 106.796C98.4826 105.13 99.7746 102.811 100.16 100.268L107.52 52.268C107.752 50.7392 107.649 49.1783 107.218 47.6933C106.787 46.2084 106.038 44.8349 105.024 43.668C104.009 42.5012 102.753 41.5689 101.342 40.9358C99.9313 40.3027 98.3998 39.9838 96.8537 40.0013H66.667Z",
    stroke: "#B30200",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs_up.627f9fd6c9f71ebf040484fb37ed9e5d.svg";
export { ForwardRef as ReactComponent };